(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@tcc/crate"), require("@tcc/i18n"));
	else if(typeof define === 'function' && define.amd)
		define("@tcc/product-packaging-web", ["react", "@tcc/crate", "@tcc/i18n"], factory);
	else if(typeof exports === 'object')
		exports["@tcc/product-packaging-web"] = factory(require("react"), require("@tcc/crate"), require("@tcc/i18n"));
	else
		root["@tcc/product-packaging-web"] = factory(root["react"], root["@tcc/crate"], root["@tcc/i18n"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__156__, __WEBPACK_EXTERNAL_MODULE__67__, __WEBPACK_EXTERNAL_MODULE__703__) => {
return 